import React, { Component, useState } from "react";
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import _ from "lodash";
import moment from "moment";
import repayLogo from "../../img/reepayLogo.png";

const IOSSwitch = withStyles((theme) => ({
    root: {
        width: 42,
        height: 26,
        padding: 0,
        margin: theme.spacing(1),
    },
    switchBase: {
        padding: 1,
        '&$checked': {
            transform: 'translateX(16px)',
            color: theme.palette.common.white,
            '& + $track': {
                backgroundColor: '#52d869',
                opacity: 1,
                border: 'none',
            },
        },
        '&$focusVisible $thumb': {
            color: '#52d869',
            border: '6px solid #fff',
        },
    },
    thumb: {
        width: 24,
        height: 24,
    },
    track: {
        borderRadius: 26 / 2,
        border: `1px solid ${theme.palette.grey[400]}`,
        backgroundColor: theme.palette.grey[50],
        opacity: 1,
        transition: theme.transitions.create(['background-color', 'border']),
    },
    checked: {},
    focusVisible: {},
}))(({ classes, ...props }) => {
    return (
        <Switch
            focusVisibleClassName={classes.focusVisible}
            disableRipple
            classes={{
                root: classes.root,
                switchBase: classes.switchBase,
                thumb: classes.thumb,
                track: classes.track,
                checked: classes.checked,
            }}
            {...props}
        />
    );
});

const AndroidSwitch = withStyles((theme) => ({
    root: {
        // width: 42,
        height: 26,
        padding: 0,
        margin: theme.spacing(1),
    },
    switchBase: {
        padding: 1,
        '&$checked': {
            transform: 'translateX(32px)',
            color: theme.palette.common.white,
            '& + $track': {
                backgroundColor: '#52d869',
                border: 'none',
                opacity: 1
            },
        },
        '&$focusVisible $thumb': {
            color: '#52d869',
            border: '6px solid #fff',
        },
    },
    thumb: {
        width: 18,
        height: 20,
        borderRadius: 3,
        marginLeft: 3,
        marginTop: 2
    },
    track: {
        borderRadius: 3,
        border: `1px solid ${theme.palette.grey[400]}`,
        backgroundColor: theme.palette.grey[50],
        opacity: 1,
        transition: theme.transitions.create(['background-color', 'border']),
    },
    checked: {},
    focusVisible: {},
}))(({ classes, ...props }) => {
    return (
        <Switch
            focusVisibleClassName={classes.focusVisible}
            disableRipple
            classes={{
                root: classes.root,
                switchBase: classes.switchBase,
                thumb: classes.thumb,
                track: classes.track,
                checked: classes.checked,
            }}
            {...props}
        />
    );
});


class TableBody extends Component {
    renderCell = (item, column) => {
        if (column.content) return column.content(item);
        return _.get(item, column.path);
    };


    handleChange = (event, therapistId) => {
        this.props.handleSwitchChange(event, therapistId);
    };

    handleCellClick = (event, item, column) => {
        this.props.onCellClick(event, item, column);
    }

    render() {
        const { data, columns, idProperty } = this.props;
        return (
            <React.Fragment>
                <tbody>
                    {data.map(item => (
                        <tr key={item[idProperty]}>
                            {columns.map(column => (
                                <td style={{ "paddingLeft": column.type === "switch" ? "40px" : "" }} key={`${item[idProperty]}${column.path || column.key}`}>
                                    {(() => {
                                        switch (column.type) {
                                            case 'switch':
                                                return (<FormControlLabel
                                                    control={<IOSSwitch checked={this.renderCell(item, column)} name="TherapistAvailable" onChange={(e) => this.handleChange(e, item[idProperty])} />}
                                                    label=""
                                                />);
                                            case 'TextLink':
                                                return (
                                                    <span className="text-link" onClick={(e) => this.handleCellClick(e, item, column)}>
                                                        {this.renderCell(item, column)}
                                                    </span>
                                                )
                                            case 'Date':
                                                return (
                                                    <>{this.renderCell(item, column) ? moment(this.renderCell(item, column)).format("DD/MM/YYYY") : ''}</>
                                                )
                                            case 'ReepayReminder':
                                                return (
                                                    <span className="ReepayReminder">
                                                        {this.renderCell(item, column) ? moment(this.renderCell(item, column)).format("DD/MM/YYYY") : ''}
                                                        <img src={repayLogo} className="repayLogo" width="40px" alt="RepayLogo" />
                                                    </span>
                                                )
                                            case 'payment':
                                                const value = this.renderCell(item, column);
                                                return +value ? (
                                                    <span className={value < 0 ? 'color-red' : ''}>{value}</span>
                                                ) : (value);

                                            case 'Action':
                                                return (
                                                    <div className="flex-center table-action">
                                                        <FormControlLabel
                                                            control={<AndroidSwitch className="AndroidSwitch" checked={!this.renderCell(item, column)} name="TherapistAvailable" onChange={(e) => this.handleCellClick('OnOff', item, column)} />}
                                                            label=""
                                                        />
                                                        <Button
                                                            size="small"
                                                            variant="text"
                                                            color="secondary"
                                                            className="btn-dange"
                                                            onClick={(e) => this.handleCellClick('delete', item, column)}
                                                        >Slet</Button>
                                                    </div>
                                                )
                                            default:
                                                return (this.renderCell(item, column));
                                        }
                                    })()}
                                </td>
                            ))}
                        </tr>
                    ))}
                </tbody>
            </React.Fragment>
        );
    }
}
TableBody.defaultProps = {
    idProperty: "id"
};
export default TableBody;
